import { saveAs } from "file-saver";
import { showNotificationError } from "~/core/utils/notifications";
import { i18n } from "~/plugins/i18n";

export function downloadJsonFile<T>(data: T, fileName: string = "data.json") {
  if (data) {
    const jsonStringify = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonStringify], {
      type: "application/json",
    });
    saveAs(blob, fileName.endsWith(".json") ? fileName : `${fileName}.json`);
  } else {
    showNotificationError(i18n.global.t("errors.download.noData"));
  }
}
